module.exports = __webpack_public_path__ + "static/media/DecPassportFront.92e38c39.tsx";